var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$attrs.class,attrs:{"viewBox":_vm.$attrs.viewBox || '0 0 16 16',"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.path)}})}
var staticRenderFns = []

export { render, staticRenderFns }